import { render, staticRenderFns } from "./OrderLogistic.vue?vue&type=template&id=e7addae6&"
import script from "./OrderLogistic.vue?vue&type=script&lang=js&"
export * from "./OrderLogistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports